import { TenantType } from '../../enums'
import { PublicTenant } from '../../models'

export const defaultPublicTenant: PublicTenant = {
  fullAddress: '',
  id: '',
  logoUrl: '',
  mail: '',
  maxAmount: 10,
  name: '',
  phone: '',
  serviceCategories: [],
  theme: [],
  timezone: 'Europe/Berlin',
  type: TenantType.FOOD,
  useLengthOfStay: false,
  openOnHoliday: false,
  termsForReservation: '',
  cancelationNote: '',
  features: [],
  customerCustomConditions: [],
}
